<script>
import { mapState, mapActions } from 'vuex';
import { isEmpty } from 'lodash-es';

export default {
  name: 'ProductsControl',
  props: {
    selectedChannel: {
      type: Object,
      required: true,
    },
    selectedType: {
      type: Object,
      required: true,
    },
    loadNewPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pricesBeforeToday: false,
      stepper: 1,
      channel: {},
      channelChip: false,
      type: {},
      typeChip: false,
      fromDateMenu: false,
      fromDate: '',
      fromDateFormatted: null,
      toDateMenu: false,
      toDate: '',
      toDateFormatted: null,
      channelProduct: {},
      channelProductRules: [
        v => !this.isObjectEmpty(v) || 'Channel product is required',
      ],
      fromDateRules: [
        v => !v || this.checkValidDate(v) || 'Date is not valid',
        v => !v || !this.$moment(v, 'DD-MM-YYYY', true).isAfter(this.$moment(this.toDate), 'day') || 'From date cannot be after To date',
        v => this.checkValidDate(v) || (!this.checkValidDate(v) && !this.checkValidDate(this.toDateFormatted)) || 'From date is required when To date is set',
      ],
      toDateRules: [
        v => !v || this.checkValidDate(v) || 'Date is not valid',
        v => !v || !this.fromDate || !this.$moment(v, 'DD-MM-YYYY', true).isBefore(this.$moment(this.fromDate), 'day') || 'To date cannot be before From date',
        v => this.checkValidDate(v) || (!this.checkValidDate(v) && !this.checkValidDate(this.fromDateFormatted)) || 'To date is required when From date is set',
      ],
    };
  },
  computed: {
    ...mapState({
      filter: state => state.prices.filter,
      channelProducts: state => state.prices.channelProducts,
    }),
  },
  methods: {
    ...mapActions({
      getJobs: 'prices/getJobs',
      getPricesImport: 'prices/getPricesImport',
      getPricesPush: 'prices/getPricesPush',
      getChannelProducts: 'prices/getChannelProducts',
      clearChannel: 'prices/clearChannel',
      clearType: 'prices/clearType',
      resetPricesList: 'prices/resetPricesList',
      resetPricesPaginationIndex: 'prices/resetPricesPaginationIndex',
      updatePricesPaginationIndex: 'prices/updatePricesPaginationIndex',
      testConst: 'prices/testConst',
    }),
    dateInputChange(type) {
      if (type === 'from') {
        this.fromDate = this.fromDateFormatted ? this.$moment(this.fromDateFormatted, 'DD-MM-YYYY', true).format('YYYY-MM-DD') : '';
      } else {
        this.toDate = this.toDateFormatted ? this.$moment(this.toDateFormatted, 'DD-MM-YYYY', true).format('YYYY-MM-DD') : '';
      }
      this.$refs.form.validate();
    },
    checkValidDate(date) {
      const momentDate = this.$moment(date, 'DD-MM-YYYY', true);
      return momentDate.isValid();
    },
    show(chosen) {
      return !isEmpty(chosen);
    },
    toDateSelected(date) {
      this.toDate = date;
      this.toDateFormatted = this.$moment(date).format('DD-MM-YYYY');
      this.toDateMenu = false;
    },
    fromDateSelected(date) {
      this.fromDate = date;
      this.fromDateFormatted = this.$moment(date).format('DD-MM-YYYY');
      this.fromDateMenu = false;
    },
    isObjectEmpty(object) {
      return isEmpty(object);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.searchPrices();
      }
    },
    searchPrices() {
      let filters = {};
      filters = {
        page: this.filter.paginationIndex,
        limit: 200,
        xmlChannelProductId: this.channelProduct.id,
      };
      if (this.fromDateFormatted !== null && this.toDateFormatted !== null) {
        filters.period = {
          from: this.fromDate,
          to: this.toDate,
        };
      }
      if (this.selectedType.type === 'import') {
        this.getPricesImport({ xmlJobId: this.selectedType.id, filters });
      } else {
        filters.oldPrices = this.pricesBeforeToday;
        this.getPricesPush({ xmlChannelProductId: this.channelProduct.id, filters });
      }
    },
    searchButtonClick() {
      this.resetPricesPaginationIndex();
      this.validate();
    },
    clearFilter() {
      //  clears filter values
      this.pricesBeforeToday = false;
      this.fromDate = null;
      this.fromDateFormatted = null;
      this.toDate = null;
      this.toDateFormatted = null;
      this.channelProduct = {};
      this.resetPricesList();
    },
  },
  watch: {
    loadNewPage() {
      if (this.$refs.form.validate()) {
        this.updatePricesPaginationIndex();
        this.searchPrices();
      } else {
        this.$vuetify.goTo('form', 'easeInOutCubic');
      }
    },
    selectedChannel() {
      this.channel = this.selectedChannel;
      this.channelChip = !this.isObjectEmpty(this.selectedChannel);
      this.stepper =
        this.isObjectEmpty(this.selectedChannel) ? this.stepper -= 1 : this.stepper += 1;
      if (!this.isObjectEmpty(this.selectedChannel) && this.isObjectEmpty(this.selectedType)) {
        this.getJobs(this.channel.id);
      }
    },
    selectedType() {
      this.type = this.selectedType;
      this.typeChip = !this.isObjectEmpty(this.selectedType);
      this.stepper =
        this.isObjectEmpty(this.selectedType) ? this.stepper -= 1 : this.stepper += 1;
      if (!this.isObjectEmpty(this.selectedType)) {
        this.getChannelProducts(this.selectedChannel.id);
      }
    },
    channelChip() {
      if (!this.channelChip) {
        this.clearChannel();
        this.typeChip = false;
      }
    },
    typeChip() {
      if (!this.typeChip) {
        if (this.selectedType.type === 'push') {
          this.channelChip = false;
        }
        this.clearFilter();
        this.clearType();
      }
    },
  },
  destroyed() {
    this.clearFilter();
  },
};
</script>

<template>
  <v-container class="ma-0 fluid">
    <v-layout ref="top" row align-center>
      <v-flex>
        <v-stepper v-model="stepper">
          <v-stepper-header>
            <v-stepper-step
              :complete="stepper > 1"
              step="1"
            >
              Select channel
            </v-stepper-step>

            <v-divider />

            <v-stepper-step
              :complete="stepper > 2"
              step="2"
            >
              Select type
            </v-stepper-step>

            <v-divider />

            <v-stepper-step step="3"
            >
              Search
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-flex>
    </v-layout>
    <v-form
      ref="form"
    >
      <v-layout ref="top" class="ma-2" row align-center>
        <div class="text-xs-center ml-2">
          <v-chip
            v-model="channelChip"
            close
          >
            Channel: {{ this.selectedChannel.webservice }}
          </v-chip>
        </div>
        <div class="text-xs-center ml-2">
          <v-chip
            v-if="show(this.selectedType)"
            v-model="typeChip"
            close
          >
            {{ this.selectedType.type === 'import'
            ? `Type: ${this.selectedType.type.toUpperCase()}, job: ${this.selectedType.id}`
            : `Type: ${this.selectedType.type.toUpperCase()}` }}
          </v-chip>
        </div>
        <div class="text-xs-center ml-2">
          <v-chip v-if="show(this.selectedType)">
            Currency: {{ this.selectedChannel.currency }}
          </v-chip>
        </div>
      </v-layout>
      <v-layout ref="top" class="ma-2" row align-center>
        <v-flex v-if="show(this.selectedType)" class="ml-4" md2>
          <v-menu
            v-model="fromDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            max-width="290px"
            min-width="290px"
            full-width
            offset-y
            lazy
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fromDateFormatted"
                @change="dateInputChange('from')"
                @click:append="fromDateMenu = !fromDateMenu"
                :rules="fromDateRules"
                return-masked-value
                mask="##-##-####"
                label="From Date"
                append-icon="event"
                placeholder="DD-MM-YYYY (Optional)"
              ></v-text-field>
            </template>
            <v-date-picker
              @input="fromDateSelected"
              :value="fromDate"
              no-title
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex v-if="show(this.selectedType)" class="ml-4" md2 >
          <v-menu
            v-model="toDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            max-width="290px"
            min-width="290px"
            full-width
            offset-y
            lazy
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="toDateFormatted"
                @change="dateInputChange('to')"
                @click:append="toDateMenu = !toDateMenu"
                :rules="toDateRules"
                return-masked-value
                mask="##-##-####"
                label="To Date"
                append-icon="event"
                placeholder="DD-MM-YYYY (Optional)"
              ></v-text-field>
            </template>
            <v-date-picker
              @input="toDateSelected"
              :min="fromDate"
              :value="toDate"
              no-title
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex v-if="show(this.selectedType)" class="ml-4" md6>
          <v-autocomplete
            v-model="channelProduct"
            :items="channelProducts.items"
            :placeholder="selectedType.type === 'import' ? 'Optional' : 'Required'"
            :rules="selectedType.type === 'import' ? [] : channelProductRules"
            item-text="tbName"
            label="Channel products"
            return-object
            clearable
          />
        </v-flex>
        <v-flex
          v-if="show(this.selectedType) && this.selectedType.type === 'push'" class="ml-4" md2
        >
          <v-checkbox
            v-model="pricesBeforeToday"
            label="Prices before today"
          ></v-checkbox>
        </v-flex>
        <v-flex v-if="show(this.selectedType)">
          <v-btn
            @click="searchButtonClick"
            class="right align-center"
            primary
          >
            Search
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/prices/PricesControl.vue